import React from "react";
import { Box, Typography } from "@mui/material";
import ReportList from "../pages/reports/ReportList";

const ReportContainer = () => {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <Typography
        variant="h3"
        sx={{ mb: 1, fontWeight: "bold", color: "#333" }}
      >
        Welcome to Reports
      </Typography>
      <Typography variant="h6" sx={{ mb: 8, color: "#666" }}>
        Here you get tabular information about montly transactions plus you can
        export them with ease.
      </Typography>
      <ReportList />
    </Box>
  );
};

export default ReportContainer;
